import {
    RuntimeEnvSchema,
    RuntimeEnv,
    RUNTIME_ENV_DEFAULTS,
} from './runtimeEnvSchema';

declare global {
    interface Window {
        __ENV__?: Record<string, unknown>;
    }
}

let cachedEnv: RuntimeEnv | null = null;

/**
 * Loads and validates runtime environment from window.__ENV__
 * Falls back to defaults if env.js didn't load or validation fails
 */
export function getRuntimeEnv(): RuntimeEnv {
    if (cachedEnv) {
        return cachedEnv;
    }

    if (typeof window.__ENV__ === 'undefined') {
        console.warn(
            '[RuntimeEnv] window.__ENV__ is not defined. ' +
                'Sentry and Highlight will not be initialized. ' +
                'This is expected in local development without env.js configuration.'
        );
        cachedEnv = RUNTIME_ENV_DEFAULTS;
        return cachedEnv;
    }

    const result = RuntimeEnvSchema.safeParse(window.__ENV__);

    if (!result.success) {
        console.error(
            '[RuntimeEnv] Failed to parse window.__ENV__:',
            result.error.format()
        );
        console.warn('[RuntimeEnv] Falling back to default values.');
        cachedEnv = RUNTIME_ENV_DEFAULTS;
        return cachedEnv;
    }

    cachedEnv = result.data;
    return cachedEnv;
}
